import Vue from 'vue';
import { GLOBAL_ERROR, INITIAL_APPLICATION } from '@/utils/constants';
import {
  getApplication as getApplicationCall,
  clearApplication as clearApplicationCall
} from '../../api/application';

export async function getApplication({ commit, dispatch }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['applicationLoading', true]);
      let application = await getApplicationCall();
      commit('setApplication', application);
      commit('setState', ['applicationLoading', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['applicationLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getApplication')
      });
      return reject();
    }
  });
}

export async function clearApplicationRequest({ commit, dispatch }) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['clearingApplication', true]);
      await clearApplicationCall();
      commit('setApplication', INITIAL_APPLICATION);
      commit('setState', ['clearingApplication', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['clearingApplication', true]);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('clearApplicationRequest')
      });
      return reject();
    }
  });
}
